import React, { useState, useEffect, useRef } from "react";
import 'react-nice-dates/build/style.css'
import "../../../RdssForms/rdssforms.scss";
import Modalbox from "../../DashboardComponents/ModalBox/ModalBox";
import { Link } from "react-router-dom";
import { GrDownload, GrUpload } from "react-icons/gr";

// Images
import FieldComponent from "../../../FieldComponent";
import MyTooltip from "./MyTooltip";

const Sop311 = (props: any) => {
    const [fields, setFields] = useState<any[]>([]);
    const [year, setYear] = useState<any>(props.year);
    const [roleid, setRoleid] = useState<any>(0);
  
    useEffect(() => {
        setFields(props.fields)
    }, [props.fields]);

    useEffect(() => {
        setYear(props.year);
    }, [props.year]);

    useEffect(() => {
        setRoleid(sessionStorage.getItem('roleid'))
    }, [roleid]);
    return (
        <>
        {/* SoP-3.1.1 */}
        {fields.length ?
            <>
            <tr>
                <td colSpan={5}></td>
            </tr>
            <tr>
                <td colSpan={5} className="blankPara SoP">
                    <div className="d-flex justify-content-between align-item-center">
                        <div className="d-flex align-items-center w-100">
                            <p className="mb-0 ps-2 fw-medium pe-3">SoP-3.1.1</p>
                            {roleid == 5 || roleid == 6 || props.iscompletedsubmittedstatus == 1 ?
                                <>
                                {props.submittedStatus == 1 ?
                                    <>
                                    <select defaultValue={fields[225] && fields[225].value ? fields[225].value : ''} name="formdata[pqsop_details][sop311_nodal]" id="pqsop_details_sop311_nodal" className="form-select text-start">
                                        <option value="">Select</option>
                                        <option value="Compliant">Compliant</option>
                                        <option value="Partial Compliant">Partial Compliant</option>
                                        <option value="Non-Compliant">Non-Compliant</option>
                                        <option value="Compliant with Delay">Compliant with Delay</option>
                                    </select>

                                    <div className="col-md-0">
                                        {/* <p className="mb-0 ps-2 fw-medium pe-3">Remarks</p> */}
                                        <div className="form-group text">
                                            <div className="form-field">
                                                <input autoComplete="off" className="form-control" type="text" name="formdata[pqsop_details][sop311_remarks_nodal]" id="pqsop_details_sop311_remarks_nodal" defaultValue={fields[240] && fields[240].value ? fields[240].value : ''} />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="fileUpload position-relative text-center">
                                        <div className="dowupEqule">
                                            <input type="file" autoComplete="off" className="form-control" name="formdata[pqsop_details][sop311_document_nodal]" id="pqsop_details_sop311_document_nodal" />
                                            <div className="customUpload justify-content-center flex-wrap">
                                                <span> <GrUpload /> </span>
                                                {/* <span>.PDF, .Docx, .XLS</span> */}
                                            </div>
                                        </div>
                                        {fields[255].value != '' ?
                                            <a href={fields[255].value} title={fields[255].value} className="viewupload" target="_blank"><GrDownload /></a>
                                            : null
                                        }
                                    </div>

                                    </>
                                    :
                                    <>

                                    {fields[225].value != '' ?
                                        <div className="col-md-0">
                                            <div className="form-group select">
                                                <div className="form-field">
                                                    <div className="view-field text-start">
                                                        {fields[225] && fields[225].value ? fields[225].value : ''}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        : null
                                    }

                                    {/* {fields[240].value != '' ? */}
                                    <div className={"view-field text-start"}> {fields[240] && fields[240].value ? fields[240].value : ''}</div>
                                    {/* : null
                                                    } */}

                                    {fields[255].value != '' ?
                                        <div className="view-field text-center">
                                            <a href={fields[255] && fields[255].value ? fields[255].value : ''} title={fields[255] && fields[255].value ? fields[255].value : ''} className="viewupload" target="_blank">
                                                <span><GrDownload /></span>
                                            </a>
                                        </div>
                                        : null
                                    }

                                    </>
                                }
                                </> : null
                            }

                        </div>
                        {(props.tooltip !== undefined && props.tooltip === false)
                            ? null
                            :
                            <MyTooltip placement="left">
                                <ul>
                                    <li>Relevant Extract of tariff petition /Tariff order</li>
                                    <li>Copy of Government Order/Directive, If any</li>
                                    <li>Govt order/declaration/ communication  for  consumer catergory wise tariff subsidy on per unit basis</li>
                                </ul>
                            </MyTooltip>
                        }
                    </div>
                </td>
            </tr>
            <tr>
                <td>Does the tariff petition seek to determine tariff on full cost basis without considering any tariff subsidy from the State Government?</td>
                <td className="tableRadio">
                    <FieldComponent options={{ showTitle: false }} fieldName={fields[76].key} field={fields[76]} />
                </td>
                <td>
                    <FieldComponent options={{ showTitle: false }} fieldName={fields[78].key} field={fields[78]} />
                </td>
                <td>
                    <FieldComponent options={{ showTitle: false }} fieldName={fields[77].key} field={fields[77]} />
                </td>
                <td></td>
            </tr>
            <tr>
                <td>Whether the State has directed  SERC to determine full cost tariff as per Section 108 of EA {year} ?</td>
                <td className="tableRadio">
                    <FieldComponent options={{ showTitle: false }} fieldName={fields[79].key} field={fields[79]} />
                </td>
                <td>
                    <FieldComponent options={{ showTitle: false }} fieldName={fields[81].key} field={fields[81]} />
                </td>
                <td>
                    <FieldComponent options={{ showTitle: false }} fieldName={fields[80].key} field={fields[80]} />
                </td>
                <td></td>
            </tr>
            <tr>
                <td>Whether any tariff subsidy is declared by State Govt?</td>
                <td className="tableRadio">
                    <FieldComponent options={{ showTitle: false }} fieldName={fields[82].key} field={fields[82]} />
                </td>
                <td>
                    <FieldComponent options={{ showTitle: false }} fieldName={fields[84].key} field={fields[84]} />
                </td>
                <td>
                    <FieldComponent options={{ showTitle: false }} fieldName={fields[83].key} field={fields[83]} />
                </td>
                <td></td>
            </tr>
            <tr id="if_yes">
                <td>If Yes , please mention the type of subsidy</td>
                <td>
                    <FieldComponent options={{ showTitle: false }} fieldName={fields[85].key} field={fields[85]} />
                </td>
                <td>
                    <FieldComponent options={{ showTitle: false }} fieldName={fields[87].key} field={fields[87]} />
                </td>
                <td>
                    <FieldComponent options={{ showTitle: false }} fieldName={fields[86].key} field={fields[86]} />
                </td>
                <td></td>
            </tr>
            <tr className="borderThik">
                <td>Remarks</td>
                <td colSpan={4}>
                    <FieldComponent options={{ showTitle: false }} fieldName={fields[88].key} field={fields[88]} />
                </td>
            </tr>
            </>
            : null
        }
        </>
    );
};

export default Sop311;